import React from 'react';
import PageHeader from "./PageHeader";
import PageTitle from "./PageTitle";
import RangeGraph from "./RangeGraph";

const ProgressStatements = ({key = '', category = 'SMART', currentDate  = '06/01/20', initialDate  = '06/01/20', statements = null, description = null}) => {
    return (
        <div className='Overview' key={key}>
            <PageHeader title={'RESULTS'} />

            <div className={'container progress-brief'}>
                <PageTitle title={`${category} STATEMENTS`} />
                <p dangerouslySetInnerHTML={{ __html: description }} />
                <div className="flex items-center space-x-8 mb-10 mt-8">
                    <div className="flex items-center">
                        <span className="inline-block w-4 h-4 bg-gray-800 mr-2" />
                        <span className="text-14"><span className={'font-bold'}>Current Assessment:</span> {currentDate}</span>
                    </div>
                    <div className="flex items-center">
                        <span className="inline-block w-4 h-4 bg-gray-400 mr-2" />
                        <span className="text-14"><span className={'font-bold'}>Initial Assessment:</span> {initialDate}</span>
                    </div>
                </div>
                <div className="space-y-6 leading-none">
                    {statements.map(({ label, current, initial }, idx) => (
                        <RangeGraph
                            key={`${category}_RANGE_GRAPH_${idx}}`}
                            current={current}
                            initial={initial}
                            question={label}
                            index={idx}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ProgressStatements;
